import React, { useEffect, useId, useRef } from "react";
import { createPortal } from "react-dom";
import ArrivalCard from "./ArrivalCard";
import "../../css/App.css";
import PropTypes from "prop-types";

export default function ArrivalsModal({ result }) {
  const [showModal, setShowModal] = React.useState(false);
  const titleId = useId();
  const dialogRef = useRef(null);
  const closeRef = useRef(null);
  const triggerRef = useRef(null);

  const arrivals = result.AvailibilityList || [];

  function closeModal() {
    setShowModal(false);
    triggerRef.current?.focus();
  }

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return undefined;

    if (showModal) {
      if (!dialog.open) {
        dialog.showModal();
      }
      closeRef.current?.focus();

      function onBackdropClick(event) {
        if (event.target === dialog) {
          closeModal();
        }
      }

      dialog.addEventListener("click", onBackdropClick);
      return () => {
        dialog.removeEventListener("click", onBackdropClick);
      };
    }

    if (dialog.open) {
      dialog.close();
    }
    return undefined;
  }, [showModal]);

  return (
    <>
      <button
        ref={triggerRef}
        type="button"
        className="arrival-trigger"
        aria-label={`Voir les ${arrivals.length} prochaines arrivages pour ${result.ProductSku}`}
        aria-haspopup="dialog"
        aria-expanded={showModal}
        data-tooltip="Consulter les prochaines livraisons"
        onClick={() => setShowModal(true)}
      >
        <span className="arrival-trigger-icon" aria-hidden="true">
          <i className="fa fa-truck" />
        </span>
        <span className="arrival-trigger-copy">
          <span className="arrival-trigger-label">Arrivages</span>
          <span className="arrival-trigger-hint">Voir le détail</span>
        </span>
        <span className="arrival-trigger-count" aria-hidden="true">
          {arrivals.length}
        </span>
      </button>
      {createPortal(
        <dialog
          ref={dialogRef}
          className="arrivals-dialog"
          aria-labelledby={titleId}
          onClose={closeModal}
          onCancel={(event) => {
            event.preventDefault();
            closeModal();
          }}
        >
          <div className="modal-title-container">
            <h3 id={titleId} className="modal-title">
              Prochaines arrivages {result.ProductSku}
            </h3>
            <button
              ref={closeRef}
              type="button"
              className="back-button"
              aria-label="Fermer la fenêtre des arrivages"
              onClick={closeModal}
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
          <div className="modal-content">
            {arrivals.length === 0 ? (
              <p className="arrivals-empty">Aucun arrivage à afficher.</p>
            ) : (
              arrivals.map((item, index) => (
                <ArrivalCard
                  key={`${item.ProductSku}-${item.ArrivalDate || item.AvailibilityDate || index}`}
                  item={item}
                />
              ))
            )}
          </div>
        </dialog>,
        document.body
      )}
    </>
  );
}

ArrivalsModal.propTypes = {
  result: PropTypes.shape({
    ProductSku: PropTypes.string,
    AvailibilityList: PropTypes.array,
  }).isRequired,
};
